import { RT_API_USAGE } from 'src/store/ActionTypes';

/**
 * fetchConfig - Fetch a realtime API config by ID
 * @param payload {string} - config ID
 * @returns {{payload: string, type: string}}
 */
export const fetchConfig = (payload) => ({
  type: RT_API_USAGE.FETCH_CONFIG,
  payload,
});

/**
 * fetchConfigList - Fetch a list of realtime API configs
 * @param payload {string} - querystring for a config list
 * @returns {{payload: string, type: string}}
 */
export const fetchConfigList = (payload) => ({
  type: RT_API_USAGE.FETCH_CONFIG_LIST,
  payload,
});

/**
 * generateStats - Generate the stat counts from usage entries
 *
 * @param {boolean} countMatches - whether matches should be counted for stats instead of total calls
 * @returns {{type: string, payload: { countMatches: boolean }}}
 */
export const generateStats = (countMatches) => ({
  type: RT_API_USAGE.GENERATE_STATS,
  payload: {
    countMatches,
  },
});

/**
 * fetchEntries - Fetch a list of tracking entries for realtime API usage
 * @param payload {string} - querystring for a tracking entry list
 * @returns {{payload: string, type: string}}
 */
export const fetchEntries = (payload) => ({
  type: RT_API_USAGE.FETCH_ENTRIES,
  payload,
});

/**
 * unset - Reset a redux state key to its default
 * @param key {string} the state key to reset
 * @returns {{payload: string, type: string}}
 */
export const unset = (key) => ({
  type: RT_API_USAGE.UNSET,
  payload: key,
});
